// SHADOW MARKET™ — TopWallet Comparator page.
import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { ASSETS } from "../assets";
import { LanguageSwitcher } from "../components/LanguageSwitcher";
import { useLanguage } from "../i18n/LanguageContext";
import { ComparadorWallets } from "../components/ComparadorWallets";
import { getComparadorUi } from "../i18n/comparador-wallets";

const TopWalletComparadorPage = () => {
  const { lang } = useLanguage();
  const ui = getComparadorUi(lang);

  return (
    <div className="relative min-h-screen overflow-x-hidden bg-black text-white">
      <div className="pointer-events-none fixed inset-0">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(59,130,246,0.20),transparent_55%)]" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_60%,rgba(0,229,255,0.12),transparent_55%)]" />
      </div>

      <header className="relative z-20 border-b border-white/5 bg-black/60 backdrop-blur-xl">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-3 px-4 py-3 md:px-10 md:py-4">
          <Link
            to="/#topwallet"
            className="inline-flex items-center gap-2 text-white/70 transition-colors hover:text-white"
            data-testid="comparador-back"
          >
            <ArrowLeft className="h-4 w-4" />
            <span className="text-xs font-bold uppercase tracking-[0.2em]">TopWallet</span>
          </Link>
          <img src={ASSETS.logos.rebel} alt="REBEL" className="h-8 w-auto md:h-10" />
          <LanguageSwitcher />
        </div>
      </header>

      <main className="relative z-10 mx-auto max-w-6xl px-4 py-8 md:px-10">
        <div className="mb-3 inline-flex items-center gap-2 rounded-full border border-blue-400/25 bg-blue-400/5 px-3 py-1 backdrop-blur">
          <span className="h-1.5 w-1.5 rounded-full bg-blue-400 shadow-[0_0_8px_rgba(59,130,246,0.8)]" />
          <span className="text-[10px] font-bold uppercase tracking-[0.25em] text-blue-200">
            {ui.eyebrow}
          </span>
        </div>
        <h1
          className="mt-3 font-display text-3xl font-black tracking-tight md:text-5xl"
          data-testid="comparador-title"
        >
          {ui.title}
        </h1>
        <p className="mb-8 mt-2 text-sm text-white/65 md:text-base">{ui.subtitle}</p>

        <ComparadorWallets />
      </main>
    </div>
  );
};

export default TopWalletComparadorPage;
